module.exports = __webpack_public_path__ + "img/pic4@2x.05027b00.png";